// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/movimenti-magazzino/righe?societaId=&tipo=&stato=&depositoId=',
    requestBody: null,
    response: '{ success: true, data: [{ rigaId, ordine, articolo, quantita, prezzoUnitario, segno, note, movimento: { id, numero, anno, data, stato, descrizione, causale, depositoOrigine, depositoDestinazione, nominativo, commessa } }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/causali-movimento?societaId=&attivo=true',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, tipo, aggiornaCmp, isDefault, attivo }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/depositi?societaId=',
    requestBody: null,
    response: '{ depositi: [{ id, nome, tipo }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-magazzino',
    requestBody: '{ societaId, causaleId, data, depositoOrigineId, depositoDestinazioneId, descrizione, numeroDocumentoEsterno, dataDocumentoEsterno, note }',
    response: '{ success: true, data: { id } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
